import { WlCache } from './cache';

import { IconRegistry } from './registry/icons/IconRegistry';
import { ComponentRegistry } from './registry/components/ComponentRegistry';

import { getWlConfig } from 'config/wls/wlConfig';

export async function bootstrapWl(wlId: number): Promise<void> {
  const config = getWlConfig(wlId);
  if (config) {
    const cached = WlCache.get(`wl-${wlId}`, config.version);

    if (cached) {
      restoreFromCache(cached);
      return;
    }
  }

  IconRegistry.clear();
  ComponentRegistry.clear();
}

function restoreFromCache(cached: any) {
  if (cached.activeIconPack) {
    IconRegistry.setActivePack(cached.activeIconPack);
  }

  if (cached.components) {
    Object.entries(cached.components).forEach(([name, config]: any) => {
      ComponentRegistry.register(name, config);
    });
  }
}
